import { QUESTION_REPORT_TYPES } from "@/Enums/question_report_types";
import {
  IconReportTypeAverage,
  IconReportTypeLatest,
  IconReportTypeTotal,
} from "@/Icons";
import React from "react";

const ResultTypeIcon = ({ resultType = null }) => {
  switch (resultType) {
    case QUESTION_REPORT_TYPES.Average:
      return <IconReportTypeAverage />;
    case QUESTION_REPORT_TYPES.Latest:
      return <IconReportTypeLatest />;
    default:
      return <IconReportTypeTotal />;
  }
};

export default ResultTypeIcon;
